import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

import FactCheckIcon from "@mui/icons-material/FactCheck";
import localisation from "../../localisation";

export type ImportStage = "PreCheck" | "Import";

export type FileNameConflictDialogState = {
    showDialog: boolean;
    importStage: ImportStage;
    fileName: string;
    lastImportDate: Date | null;
};

export type FileNameConflictDialogProps = {
    handleForceUploadDecision: (forceUploadDecision: boolean, importStage: ImportStage) => void;
} & FileNameConflictDialogState;

const FileNameConflictDialog = (props: FileNameConflictDialogProps) => {
    const { handleForceUploadDecision, showDialog, importStage, fileName, lastImportDate } = props;

    const { cancelButtonText, confirmButtonText, contentText, titleText, errorGettingDateText } = localisation.fileNameConflictDialog;

    return (
        <Dialog open={showDialog} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Box>
                <DialogTitle id="alert-dialog-title">{titleText}</DialogTitle>

                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {contentText.replace("{FILENAME}", fileName).replace("{LASTIMPORTDATE}", lastImportDate ? new Date(lastImportDate).toLocaleString() : errorGettingDateText)}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        autoFocus
                        onClick={() => handleForceUploadDecision(false, importStage)}
                    >
                        {cancelButtonText}
                    </Button>
                    <Button
                        color="primary"
                        variant="outlined"
                        endIcon={<FactCheckIcon />}
                        onClick={() => handleForceUploadDecision(true, importStage)}
                    >
                        {confirmButtonText}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export { FileNameConflictDialog };
